__turbopack_context__.v({
  "active": "ThemeSwitcher-module-scss-module__zFUIbq__active",
  "chevron": "ThemeSwitcher-module-scss-module__zFUIbq__chevron",
  "collapsed": "ThemeSwitcher-module-scss-module__zFUIbq__collapsed",
  "option": "ThemeSwitcher-module-scss-module__zFUIbq__option",
  "select-item": "ThemeSwitcher-module-scss-module__zFUIbq__select-item",
  "select-trigger": "ThemeSwitcher-module-scss-module__zFUIbq__select-trigger",
  "select-viewport": "ThemeSwitcher-module-scss-module__zFUIbq__select-viewport",
  "trigger-option": "ThemeSwitcher-module-scss-module__zFUIbq__trigger-option",
});
